import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import './App.css';

function RefundPolicy() {
  return (
    <div className="App">
      <Navigation />
      
      <header className="App-header">
        <div className="page-content">
          <h1>Refund & Cancellation Policy</h1>
          
          <div className="legal-content">
            <p><strong>Last updated:</strong> November 4, 2025</p>
            
            <section className="legal-section">
              <h2>1. Cancellation Policy</h2>
              <p>We understand that plans can change. Our cancellation policy is designed to be fair to both our customers and our business operations.</p>
              
              <h3>1.1 Cancellation Timeline</h3>
              <ul>
                <li><strong>More than 30 days before booking:</strong> Full refund minus 5% processing fee</li>
                <li><strong>15-30 days before booking:</strong> 75% refund of total amount paid</li>
                <li><strong>7-14 days before booking:</strong> 50% refund of total amount paid</li>
                <li><strong>Less than 7 days before booking:</strong> No refund (cancellation fee applies)</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>2. Refund Process</h2>
              <p>Refunds will be processed according to the following guidelines:</p>
              <ul>
                <li>Refund requests must be submitted in writing via email to hello@vidaai.com</li>
                <li>Refunds will be processed within 7-10 business days from the date of cancellation approval</li>
                <li>Refunds will be credited to the original payment method used for booking</li>
                <li>Bank processing times may vary and can take an additional 5-7 business days</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>3. Non-Refundable Items</h2>
              <p>The following items are non-refundable under any circumstances:</p>
              <ul>
                <li>Custom decoration charges (if customization work has already begun)</li>
                <li>Special requests that have been ordered or arranged specifically for your booking</li>
                <li>Cancellations made on the day of the event or after the scheduled pickup time</li>
                <li>No-shows without prior cancellation notice</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>4. Modifications to Bookings</h2>
              <p>If you need to modify your booking rather than cancel it:</p>
              <ul>
                <li>Date changes are subject to vehicle availability</li>
                <li>Modifications made more than 14 days before the event are free of charge</li>
                <li>Modifications made 7-14 days before the event may incur a 10% modification fee</li>
                <li>Modifications less than 7 days before the event are subject to approval and may incur a 25% modification fee</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>5. Force Majeure</h2>
              <p>In case of unforeseen circumstances beyond our control, including but not limited to:</p>
              <ul>
                <li>Natural disasters (floods, earthquakes, severe weather)</li>
                <li>Government restrictions or lockdowns</li>
                <li>Vehicle breakdown due to manufacturer defects</li>
                <li>Accidents or incidents not caused by negligence</li>
              </ul>
              <p>We will offer the following options:</p>
              <ul>
                <li>Full refund of all payments made</li>
                <li>Rescheduling to a mutually agreed date with no additional charges</li>
                <li>Credit note valid for 12 months for future bookings</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>6. Refund for Service Issues</h2>
              <p>If you experience service issues on the day of your booking:</p>
              <ul>
                <li>Vehicle does not meet the promised specifications or condition</li>
                <li>Vehicle arrives more than 30 minutes late without prior notification</li>
                <li>Chauffeur behavior is unprofessional or inappropriate</li>
              </ul>
              <p>You must report the issue immediately to our customer service team. We will investigate and may offer:</p>
              <ul>
                <li>Partial refund based on the severity of the issue</li>
                <li>Full refund if the service was not rendered as agreed</li>
                <li>Credit for future bookings</li>
                <li>Complimentary upgrade on your next booking</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>7. Dispute Resolution</h2>
              <p>If you have any concerns about your refund or cancellation:</p>
              <ul>
                <li>Contact our customer service team at hello@vidaai.com within 48 hours of the issue</li>
                <li>Provide all relevant details including booking reference number and supporting documentation</li>
                <li>We will investigate and respond within 3-5 business days</li>
                <li>If you are not satisfied with our response, you may escalate to our senior management team</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>8. Payment Protection</h2>
              <p>Your payment is protected by:</p>
              <ul>
                <li>Secure payment processing through verified payment gateways</li>
                <li>Encryption of all financial data</li>
                <li>Compliance with industry-standard security protocols</li>
                <li>Clear documentation of all transactions</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>9. Exceptions</h2>
              <p>BlobCity iSolutions Pvt Ltd reserves the right to make exceptions to this policy on a case-by-case basis for:</p>
              <ul>
                <li>Medical emergencies (with valid documentation)</li>
                <li>Bereavement in the immediate family</li>
                <li>Other extraordinary circumstances at management discretion</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>10. Contact Information</h2>
              <p>For any questions regarding our refund and cancellation policy, please contact us:</p>
              <p>
                <strong>BlobCity iSolutions Pvt Ltd</strong><br />
                Email: hello@vidaai.com<br />
                Phone: Available on our Contact Us page<br />
                Address: BlobCity c/o WeWork Enam Sambhav, C20, G Block<br />
                BKC, Bandra East, Mumbai, Maharashtra 400051. India.
              </p>
              <p>
                <strong>Note:</strong> This policy is subject to change. Please check this page regularly for updates. 
                Bookings made before policy changes will be governed by the policy in effect at the time of booking.
              </p>
            </section>
          </div>
        </div>
      </header>
      
      <Footer />
    </div>
  );
}

export default RefundPolicy;
